"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.otherAdjustmentSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.otherAdjustmentSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    anyOf: [
        { required: ['code', 'indexNumber', 'originalClaimSequenceNumber'] },
        { required: ['originalClaimSequenceNumber'] },
    ],
    properties: {
        code: {
            type: 'string',
            enum: Object.values(constants_1.OtherAdjustmentCode),
            errorMessage: 'Should equate to a valid OtherAdjustmentCode Enum value',
        },
        acceptableDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        amount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'Should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        amountOverrideFlag: {
            type: ['boolean', 'string', 'null'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean or null',
        },
        comment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters',
        },
        date: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        indexNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        numberOfDaysCount: {
            type: ['integer', 'null'],
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
        numberOfDaysOverrideFlag: {
            type: ['boolean', 'string', 'null'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean or null',
        },
        originalClaimSequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'Should be an integer between 0 and 32767',
        },
        previousAdjustmentAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        previousAdjustmentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        previousAdjustmentNumberOfDaysCount: {
            type: ['integer', 'null'],
            maximum: 2147483647,
            minimum: -2147483647,
            errorMessage: 'Should be an integer',
        },
    },
};
